// Full-page placeholder while a route or the session is loading.
const PageLoading = ({ label = 'Loading' }: { label?: string }) => (
    <s-page>
        <s-stack alignItems="center" padding="large-500">
            <s-spinner accessibilityLabel={label} size="large-100" />
        </s-stack>
    </s-page>
);

export default PageLoading;
